import React, { PropTypes } from 'react';
import { MenuItem, DropDownMenu, RadioButton, RadioButtonGroup, Checkbox, Table, TableRow, TableRowColumn, TableHeader, TableBody, TableHeaderColumn } from 'material-ui';
import { teams, availableAccess, permissionTypes } from '../teamPermissionOptions';
import R from 'ramda';

const SingleLocPermissions = props => {
  const {
    isAccom,
    userName,
    selectedLocs,
    onLocSelection,
    showCorporateProfileRadioButtons,
    onCorporateLocCheck,
    corporateProfileAccess,
  } = props;
  return (
    <div style={{ marginTop: '15px' }}>
      <div style={{ marginTop: '-10px', maxHeight: '300px' }}>
        {
          showCorporateProfileRadioButtons &&
          <div style={{ marginTop: '15px', display: 'inline-block', width: '100%' }}>
            <div style={{ float: 'left', width: '65%' }}>
                <span className="hint--bottom" aria-label={`Gives the user access to edit profile.`}>
                  Would you like <b>{userName}</b> to have access to edit profile?
                </span>
            </div>
            <div style={{ float: 'left', width: '35%', display: 'inline-block' }}>
              <RadioButtonGroup
                name="corporateProfile"
                defaultSelected={corporateProfileAccess ? 'yes' : 'no'}
                onChange={() => onCorporateLocCheck()} style={{ display: 'inline-block', width: '100%' }}
              >
                <RadioButton value="no" label="No" style={{ width: '50%', display: 'inline-block' }} />
                <RadioButton value="yes" label="Yes" style={{ width: '50%', display: 'inline-block' }} />
              </RadioButtonGroup>
            </div>
          </div>
        }
        <div style={{ margin: '5px 0' }}>
          Add {userName} to an optional team and set their access level below. Teams can be used to manage user permissions for different departments at your company.
        </div>
        <Table bodyStyle={{ maxHeight: '250px', overflowY: 'scroll' }}>
          <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
            <TableRow>
              <TableHeaderColumn style={{ width: '50%' }}>Team(s)</TableHeaderColumn>
              <TableHeaderColumn>Access</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            <TableRow selectable={false}>
              <TableRowColumn style={{ width: '50%' }}>
                <div style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column' }}>
                  {
                    teams.map((team, i) => (
                      <Checkbox
                        label={team}
                        key={i}
                        style={{ display: 'flex', width: '50%', marginTop: i === R.dec(teams.length) ? '15px' : '' }}
                        checked={R.contains(team, R.path([0, 'teams'], selectedLocs))}
                        onCheck={() => {
                          const locTeams = R.path([0, 'teams'], selectedLocs);
                          onLocSelection([R.merge(selectedLocs[0], { teams: R.contains(team, locTeams) ? R.without([team], locTeams) : R.append(team, locTeams) })]);
                        }}
                      />
                    ))
                  }
                </div>
              </TableRowColumn>
              <TableRowColumn style={{ overflow: 'visible' }}>
                <div style={{ display: 'flex', width: '100%', flexWrap: 'wrap' }}>
                  {
                    permissionTypes
                      .filter(type => type.value !== 'profile')
                      .map((type, k) => {
                        const loc = selectedLocs[0];
                        return (
                          <div key={k} style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                            <div style={{ width: '30%', marginLeft: '5px' }}>
                              <span className={k === R.dec(permissionTypes.length) ? 'hint--top' : 'hint--bottom'} aria-label={type.hintTextSingleLoc}>{type.label}:</span>
                            </div>
                            <div style={{ marginLeft: '8px' }}>
                              <DropDownMenu
                                value={R.path([0, 'value'], availableAccess.filter(obj => R.equals(obj.value, loc[type.value])))}
                                underlineStyle={{ borderTopColor: k === R.dec(permissionTypes.length) ? 'transparent' : '#d8d8d8' }}
                                style={{ display: 'flex', marginTop: '-10px' }}
                              >
                                {
                                  availableAccess.map((access, i) => (
                                    <MenuItem
                                      key={i}
                                      value={access.value}
                                      primaryText={access.label}
                                      label={access.label}
                                      onTouchTap={() => {
                                        onLocSelection([R.merge(selectedLocs[0], {
                                          contracting: type.value === 'contracting' ? access.value : R.path([0, 'contracting'], selectedLocs),
                                          admin: type.value === 'admin' ? access.value : R.path([0, 'admin'], selectedLocs),
                                        })]);
                                      }}
                                    />
                                  ))
                                }
                              </DropDownMenu>
                            </div>
                          </div>
                        );
                      })
                  }
                </div>
              </TableRowColumn>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

SingleLocPermissions.propTypes = {
  userName: PropTypes.string,
  location: PropTypes.object,
  selectedLocs: PropTypes.array,
  onLocSelection: PropTypes.func,
  showCorporateProfileRadioButtons: PropTypes.bool,
  onCorporateLocCheck: PropTypes.func,
  corporateProfileAccess: PropTypes.bool,
};

export default SingleLocPermissions;



// WEBPACK FOOTER //
// ./src/app/components/settings/userManagement/newUser/singleLocPermissions.jsx